export default 'Loading menu items...';